import React, { useEffect, useState } from "react";
import { Button, Card, Col, ListGroup, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import EditAdminDetailsScreen from "./EditAdminDetailsScreen";
import { useGetAdminByIdQuery } from "../slices/AdminSilce";
import {
  ACCESS_FIELDS,
  ACCESS_LABELS,
  effectiveAccess,
} from "../utils/adminAccess";

const AdminDetailsScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { state } = useLocation();

  const admins = state?.admins || [];
  const selectedAdminId = state?.selectedAdminId;
  const adminRefetch = state?.refetch;
  // const admin = admins.find((a) => a._id === selectedAdminId);
  const [isEditable, setIsEditable] = useState(false);

  const {
    data: admin,
    isLoading,
    refetch,
  } = useGetAdminByIdQuery({
    adminId: selectedAdminId,
    token: userInfo.token,
  });

  useEffect(() => {
    if (!isEditable) {
      refetch();
    }
  }, [isEditable]);

  const handleAdminEdit = () => {
    setIsEditable(true);
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <Button onClick={() => navigate("/allAdmins")}>Back</Button>
        </Col>
      </Row>

      {isEditable ? (
        <Row>
          <Col>
            <EditAdminDetailsScreen adminDet={admin} editable={setIsEditable} />
          </Col>
        </Row>
      ) : (
        <>
          <Row>
            <Col>
              <h6>Admin Details</h6>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <Card>
                <ListGroup>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Admin Name</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.adminName}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Admin Type</strong>
                      </Col>
                      <Col>
                        <strong>
                          {admin?.adminType}
                          {admin?.isPrimaryOwner ? " (primary owner)" : ""}
                        </strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>

                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Date of Birth</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.dateOfBirth?.split("T")[0]}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Address</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.address}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Mobile Number</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.mobileNumber}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Pincode</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.pincode}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Email</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.email}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Aadhar Number</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.aadharNumber}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>PAN Number</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.panNumber}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Joined Date</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.joinedDate?.split("T")[0]}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <Row>
                      <Col>
                        <strong>Work Shift</strong>
                      </Col>
                      <Col>
                        <strong>{admin?.workShift}</strong>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                </ListGroup>{" "}
                <br />
                <h5>Assiged Oulets</h5>
                <Table
                  striped
                  bordered
                  hover
                  responsive="sm"
                  className="table-custom"
                >
                  <thead className={`${userInfo.themeColor}ThemeThead`}></thead>
                  <tbody>
                    {admin?.outletId?.map((oi) => (
                      <tr key={oi._id}>
                        <td>{oi?.outletName}</td>
                        <td>{oi?.outletAddress}</td>
                        <td>
                          <td>{oi?.outletPincode}</td>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card>
            </Col>{" "}
            <Col md={5}>
              <ListGroup.Item>
                <strong>Access List</strong>
                {admin?.adminType === "Owner" && (
                  <small className="text-muted d-block">
                    Owners' access is fixed and can't be edited
                  </small>
                )}
                {admin &&
                  ACCESS_FIELDS.map((field) => {
                    const allowed = effectiveAccess(admin)[field];
                    return (
                      <Row
                        key={field}
                        className="mt-1"
                        style={{ fontSize: "0.9rem" }}
                      >
                        <Col xs={8}>{ACCESS_LABELS[field]}</Col>
                        <Col xs={4}>
                          <span
                            style={{
                              padding: "0.05rem 0.6rem",
                              borderRadius: "999px",
                              fontSize: "0.75rem",
                              fontWeight: "600",
                              backgroundColor: allowed ? "#e8f6ee" : "#f1f3f5",
                              color: allowed ? "#1e7e34" : "#6c757d",
                            }}
                          >
                            {allowed ? "Yes" : "No"}
                          </span>
                        </Col>
                      </Row>
                    );
                  })}
              </ListGroup.Item>
            </Col>
          </Row>
          &nbsp;
          <Row className="mt-3  justify-content-center">
            <Col xs="auto">
              <Button onClick={handleAdminEdit}>Edit</Button>
            </Col>
          </Row>
        </>
      )}
    </>
  );
};

export default AdminDetailsScreen;
